import { useAuth } from "./context/AuthContext";
import { Navigate, Outlet } from "react-router";
import useProfile from './customHooks/useProfile';
import { useState, useEffect } from "react";

const PendingRoute = () => {
    const { email, userVerified } = useAuth();
    const { checkProfileStatus } = useProfile();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const validate = async () => {
            if (!email) return setLoading(false);

            await checkProfileStatus();
            setLoading(false);
        };
        validate();
    }, [email]);

    console.log('User verification status: ',userVerified);
    

    if (loading) return <div>Loading...</div>;

    if (!email) return <Navigate to="/login" />;

    if (userVerified !== "IN_REVIEW") {
        if (userVerified === "PENDING") return <Navigate to="/profileform" />;
        if (userVerified === "VERIFIED") return <Navigate to="/dashboard" />;
    }

    return <Outlet />;
};

export default PendingRoute;